import { Tabs as AntdTabs } from 'antd';
import type { ComponentProps } from 'react';

import styles from './tabs.module.scss';

type AntdTabsProps = Omit<ComponentProps<typeof AntdTabs>, 'type'>;

export type TabsProps = AntdTabsProps & {
  /** Figma variants: pill = segmented control, underline = classic tabs. */
  variant?: 'pill' | 'underline';
  /** Stretch items to share the full width equally. */
  fill?: boolean;
};

export function Tabs({ variant = 'underline', fill = false, className, ...rest }: TabsProps) {
  return (
    <AntdTabs
      {...rest}
      className={[styles[variant], fill ? styles.fill : undefined, className]
        .filter(Boolean)
        .join(' ')}
    />
  );
}
